import { decryptData } from "../utils/Encryption";

export const useAuthUserToken = () => {
  let storedAuthData = {};
  let rbac = {};

  if (typeof window !== "undefined") {
    const userInfo = decryptData(localStorage.getItem("user_info"));
    storedAuthData = userInfo ? userInfo : {};

    const rbacJSON = decryptData(localStorage.getItem("rbac"));
    rbac = rbacJSON ? rbacJSON : {};
  }

  const refreshToken = storedAuthData?.refresh?.token || null;

  return {
    refreshToken,
    completeAuthData: storedAuthData,
    rbac,
  };
};
